var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", [_vm._v(_vm._s(_vm.model.Step3bTitle))]),
        _vm._v(" "),
        _c("p", { staticClass: "qualifier-tool-subheader" }, [
          _vm._v(_vm._s(_vm.model.Step3bSubTitle))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row d-flex justify-content-center qualifier-tool-footer"
      },
      [
        _c(
          "a",
          {
            staticClass: "qualifier-tool-btn",
            attrs: { href: _vm.model.Step3PaceOverviewUrl.replace("~", "..") }
          },
          [_vm._v(_vm._s(_vm.model.Step3PaceOverviewTitle))]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "qualifier-tool-status-bar" }, [
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("1")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("2")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("3")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }